module.exports = __webpack_public_path__ + "static/media/fish.83a4a239.png";